<i18n>
{
  "en": {
    "dictionary": {
      "id": "ID",
      "code": "Code",
      "name": "Name",
      "title": "Dictionary",
      "title0": "Dictionaries",
      "tabs": {
        "items": "Items",
        "attributes": "Attributes"
      }
    }
  },
  "ru": {
    "dictionary": {
      "id": "ID",
      "code": "Код",
      "name": "Наименование",
      "title": "Справочник",
      "title0": "Справочники",
      "tabs": {
        "items": "Элементы справочника",
        "attributes": "Атрибуты"
      }
    }
  }
}
</i18n>

<template>
  <div class="content-block dx-card">
    <dx-tab-panel
      :data-source="tabViews"
      :selected-index.sync="selectedTabIndex"
      @selection-changed="onSelectionChanged"
      :loop="false"
      :animation-enabled="false"
      v-if="dictionary"
    >
      <template #title="view">
        <span>{{ view.data.title }}</span>
      </template>

      <template #item="view">
        <div class="tabpanel-item">
          <component v-bind:is="view.data.id" :dictionary="dictionary">
          </component>
        </div>
      </template>
    </dx-tab-panel>
  </div>
</template>

<script>
import DxTabPanel from 'devextreme-vue/tab-panel';
import baseView from '../base.vue';
import appInfo from '../../app-info';
import DictionaryItems from './dictionary-items';
import DictionaryAttributes from './dictionary-attributes';
import { getDictionary } from '@/services/api';

export default {
  name: 'dictionary',
  props: ['id'],
  extends: baseView,
  components: { DxTabPanel, DictionaryItems, DictionaryAttributes },
  data() {
    return {
      tabViews: [{
        id: 'dictionary-items',
        title: this.$t('dictionary.tabs.items')
      }, {
        id: 'dictionary-attributes',
        title: this.$t('dictionary.tabs.attributes')
      }],
      selectedTabIndex: 0,
      dictionary: null
    };
  },
  methods: {
    async loadData(id) {
      this.loading = true;
      try {
        this.dictionary = await getDictionary(this.id);

        this.$store.commit('setBreadcrumb', [{
          link: '/dictionaries',
          title: this.$t('dictionary.title0')
        }, {
          link: `/dictionary/${id}`,
          title: this.dictionary.code
        }]);
      } catch(err) {
        this.onDataError(err);
      } finally {
        this.loading = false;
      }
    },
    onSelectionChanged(e) {
      try {
        const query = {...this.$route.query};
        switch (e.addedItems[0].id) {
          case "dictionary-items":
            delete query.tab;
            break;
          default:
            query.tab = e.addedItems[0].id;
        }
        this.$router.replace({ query });
      } catch(ignore) {
        // eslint-disable-next-line
        console.debug(ignore);
      }
    }
  },
  async created() {
    document.title = `${appInfo.title} - ${this.$t('dictionary.title')}`;
    this.loadData(this.id || this.$route.params.id);
  },
  watch: {
    id(id) {
      this.loadData(id);
    }
  }
};
</script>

<style lang="scss">
</style>
